module.exports = __webpack_public_path__ + "img/html5.bcc92f97.png";